import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { InfoTip } from './Tooltip';

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

interface OptionalBadgeProps {
  className?: string;
}

export const OptionalBadge: React.FC<OptionalBadgeProps> = ({ className }) => (
  <span
    className={cn(
      'inline-flex items-center rounded-full border border-zinc-700 bg-zinc-900 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-zinc-400',
      className,
    )}
  >
    Optional
  </span>
);

interface FormLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
  optional?: boolean;
  labelClassName?: string;
  /** Short explanation shown in an InfoTip next to the label. */
  tip?: React.ReactNode;
  tipLabel?: string;
  tipMaxWidth?: number;
}

export const FormLabel: React.FC<FormLabelProps> = ({
  children,
  required = false,
  optional = false,
  className,
  labelClassName,
  tip,
  tipLabel,
  tipMaxWidth,
  ...props
}) => (
  <label
    className={cn(
      'flex items-center gap-2 text-[14px] font-medium',
      required ? 'text-zinc-300' : 'text-zinc-400',
      className,
    )}
    {...props}
  >
    <span className={cn('inline-flex items-center gap-1', labelClassName)}>
      {children}
      {required && <span className="text-red-400">*</span>}
    </span>
    {tip && <InfoTip content={tip} label={tipLabel} maxWidth={tipMaxWidth} />}
    {optional && <OptionalBadge />}
  </label>
);
